import React from 'react';
import './styles.scss';
import { Spinner, Table } from 'react-bootstrap';
import Modal from '../../../../components/organisms/modals';
import { Delete, Pencil } from '../../../../components/atoms/icons';
import partnerByIdRes from '../../../../components/api/partner/getByIdRes.json';

interface Props {
    isLoading: boolean;
    partnerById: typeof partnerByIdRes.data | undefined;
    modal: {
        result: any;
        isLoading: boolean;
        handleDelete: () => void;
        onAfterDelete: () => void;
    }
    onNavigateToEdit: () => void;
    renderModalBody: string;
    widthHandler: {
        minWidth: string,
        width: string,
        maxWidth: string
    }
}

function RenderTablePartner(props: Props) {
  const {
    isLoading, partnerById, modal, onNavigateToEdit, renderModalBody, widthHandler,
  } = props;
  const thLabel = React.useMemo(() => ['NAME', 'COMMISSION TYPE', 'COMMISSION', 'ADDRESS', 'CITY', 'STATE', 'ACTIONS'], []);

  return (
    <div className="table-container mb-4">
      <div className="fz-18 fw-bold my-2" style={{ marginLeft: '30px' }}>Partner Detail</div>
      <Table borderless responsive>
        <thead>
          <tr>
            <th style={widthHandler}>&nbsp;</th>
            {thLabel.map((th) => (
              <th className="thead-content" key={th} style={th !== 'ACTIONS' ? { minWidth: '150px' } : { width: '50px' }}>{th}</th>
            ))}
            <th style={widthHandler}>&nbsp;</th>
          </tr>
        </thead>
        <tbody>
          {(() => {
            if (isLoading || !partnerById) {
              return (
                <tr>
                  <td colSpan={9}>
                    <div className="w-100 flexible-center my-2 fz-14 align-middle">
                      {isLoading ? <Spinner animation="border" size="sm" /> : <div className="text-center">Data Not Found</div>}
                    </div>
                  </td>
                </tr>
              );
            }
            return (
              <tr key={partnerById.id} className="align-middle my-2 fz-14">
                <td style={widthHandler}>&nbsp;</td>
                <td>{partnerById.name ?? '-'}</td>
                <td>Percentage</td>
                <td>{partnerById.comission ?? 0}</td>
                <td>{partnerById.address?.streetAddress ?? '-' }</td>
                <td>{partnerById.address?.city ?? '-'}</td>
                <td>{partnerById.address?.state ?? '-'}</td>
                <td>
                  <div className="d-flex my-2 justify-content-between align-items-center w-100 px-1">
                    <Modal.Default
                      cancelLabel="No"
                      submitLabel="Yes"
                      title="Delete Partner"
                      body={renderModalBody}
                      onSubmit={modal.handleDelete}
                      dialogClassName="custom-modal-width"
                      isLoading={modal.isLoading}
                      result={modal.result}
                      onAfterResult={modal.onAfterDelete}
                    >
                      <div style={{ marginBottom: '2px' }}>
                        <Delete width={18} />
                      </div>
                    </Modal.Default>
                    <button
                      type="button"
                      onClick={onNavigateToEdit}
                      className="bg-transparent border-0"
                    >
                      <Pencil width={20} />
                    </button>
                  </div>
                </td>
                <td style={widthHandler}>&nbsp;</td>
              </tr>
            );
          })()}
        </tbody>
      </Table>
    </div>
  );
}

export default React.memo(RenderTablePartner);
